import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const PST = 'America/Los_Angeles';

/** Today's calendar date YYYY-MM-DD in America/Los_Angeles (for "today" highlight). */
export function getTodayYmdPst() {
  return dayjs().tz(PST).format('YYYY-MM-DD');
}

/**
 * First calendar date (YYYY-MM-DD) on which a manager may confirm their own target
 * or create one that will be confirmable — matches backend:
 * ProposalServiceImpl.confirmProposal: LocalDate limitDate = todayPst.plusDays(7)
 */
export function getEarliestManagerNewTargetDateYmdPst() {
  return dayjs().tz(PST).add(7, 'day').format('YYYY-MM-DD');
}

/**
 * True when this calendar date is before that earliest date (no new manager target / confirm in window).
 */
export function isDateBeforeEarliestManagerNewTargetPst(dateYmd) {
  if (!dateYmd || typeof dateYmd !== 'string') return false;
  const d = dateYmd.slice(0, 10);
  if (d.length < 10) return false;
  return d < getEarliestManagerNewTargetDateYmdPst();
}
